// extracted by mini-css-extract-plugin
export default {"calculator":"WxDBd","form":"rlwBP","label":"ijYFy","input":"SWWp8","price":"GZ3vW","hint":"tbYQh","action":"V5sD3","modalView":"jHMH1"};